module.exports = __webpack_public_path__ + "static/media/tabs.0807bc0f.png";